import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=bbc0bbac&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=js&"
export * from "./UserSelector.vue?vue&type=script&lang=js&"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=bbc0bbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc0bbac",
  null
  
)

export default component.exports